const prizeIntroduce = [
  'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2022_goddess_festival_prize_introduce_1',
  'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2022_goddess_festival_prize_introduce_2',
  'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2022_goddess_festival_prize_introduce_3',
  'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2022_goddess_festival_prize_introduce_4',
  'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2022_goddess_festival_prize_introduce_5'
]
export { prizeIntroduce }
